import { parseBackendDateToLocal } from './dateTime';

export const LONG_RUNNING_TIMER_SECONDS = 8 * 60 * 60;

export const elapsedSecondsSince = (startedAt: string | null | undefined, now: number = Date.now()): number => {
  if (!startedAt) return 0;
  const start = parseBackendDateToLocal(startedAt);
  if (!start) return 0;
  return Math.max(0, Math.floor((now - start.getTime()) / 1000));
};

export const isLongRunning = (seconds: number): boolean => seconds >= LONG_RUNNING_TIMER_SECONDS;

/** "1:05:09" or "05:09" */
export const formatClock = (seconds: number): string => {
  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;
  const mm = mins.toString().padStart(2, '0');
  const ss = secs.toString().padStart(2, '0');
  return hrs > 0 ? `${hrs}:${mm}:${ss}` : `${mm}:${ss}`;
};
